import Anchors from './Anchors';

export default Anchors;
